define('SageDotCom/DataLayer/Events/buttonClick',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ButtonClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "button_click"; // overwrite name
    }

    ButtonClickEvent.prototype = Object.create(EventBase.prototype);

    ButtonClickEvent.prototype.GenerateEventMetadata = function(scope, label) {
        var btnClass = $(scope).attr("class") || "";

        var eventData = {
            'event_name': this.getName(),
            'event_non-int': $(scope).parents("#cookiesbanner").length > 0 ? "1" : "0",
            'event_category': "component",
            'event_action': btnClass.indexOf("ccaas") >= 0 ? "chat_icon_click" : this.getName()
        }

        if (scope) {
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || "";
            var location = this.getLocation(scope);
            var eventLabel = btnClass.indexOf("otp") >= 0 ? "OTP send" : btnClass.indexOf("ccaas") >= 0 ? "initiate" : this.cleanseString(lbl.trim());
            var link = $(scope).attr("href") || $("a:first", scope).attr("href") || "";
            var cssClass = $(scope).attr("class") || "";
            var id = this.getId(scope);
            eventData = $.extend(eventData, {
                'event_label': eventLabel, // strip any html
                'event_name_level_1': id,
                'event_name_level_2': link,
                'event_name_level_3': cssClass,
                'event_name_level_4': location,
                'destination_url': link,
                'element_text': eventLabel,
                'element_class': cssClass,
                'element_id': id,
                'element_location': location

            });

            if (btnClass.indexOf("student-trial-link") >= 0) {
                eventData = $.extend(eventData, {
                    'page_name': "try"
                });
            }
        }

        return eventData;
    }

    return new ButtonClickEvent();
});
